import { AuthenticationService, AuthenticationServiceModule } from '@b2b/common/services/auth/authentication.service';
import { UserSession } from '@b2b/common/services/auth/types';
import { extractACMEErrorMessage, extractACMEErrorType } from '@b2b/types/core';
import angular, { IHttpInterceptor, IHttpResponse, IQService, IRootScopeService } from 'angular';

type IInjectorService = ReturnType<typeof angular.injector>;

AuthInterceptorFactory.$inject = ['$q', '$rootScope', '$injector'];

function AuthInterceptorFactory($q: IQService, $rootScope: IRootScopeService, $injector: IInjectorService) {
  let lastKnownUser: UserSession | null = null;

  return {
    request: function (config) {
      const authenticationService = $injector.get<AuthenticationService>('AuthenticationService');
      lastKnownUser = authenticationService.getUserFromCookie();
      return config;
    },
    requestError: function (rejection) {
      return $q.reject(rejection);
    },
    response: function (response) {
      return response;
    },
    responseError: function (response: IHttpResponse<unknown>) {
      switch (response.status) {
        case 401:
        case 440: {
          const errorType = extractACMEErrorType(response.data);
          const errorMessage = extractACMEErrorMessage(response.data);

          switch (errorType) {
            case 'PASSWORD_EXPIRED': {
              $rootScope.$broadcast('AuthInterceptorFactory::error', {
                type: errorType,
                email: lastKnownUser?.email ?? '',
                error: {
                  type: errorType,
                  message: errorMessage,
                },
              });
              lastKnownUser = null;
              break;
            }

            default: {
              $rootScope.$broadcast('PermissionsInterceptorFactory::error', { type: 'session' });
              break;
            }
          }
        }
      }

      return $q.reject(response);
    },
  } satisfies IHttpInterceptor;
}

export const AuthInterceptorFactoryModule = angular
  .module('acme.common.factory.auth-interceptor', [AuthenticationServiceModule])
  .factory('AuthInterceptorFactory', AuthInterceptorFactory).name;
